<template
  ><div>
    <b-row class="mb-4"
      ><b-col>
        <b-button v-b-toggle="subsectionName" class="tsny_button w-100 py-2">
          Answers (Click to Expand)
        </b-button>
      </b-col></b-row
    >
    <b-row>
      <b-col>
        <b-collapse :id="subsectionName">
          <b-table-simple
            responsive
            borderless
            class="tsny_text-mid text-center"
          >
            <b-thead>
              <b-tr class="tsny_table-head">
                <b-th>
                  Question:
                </b-th>
                <b-th v-for="(question, index) in answerKey" :key="index">{{
                  index + 1
                }}</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr class="tsny_table-body">
                <b-td>
                  Your answer:
                </b-td>
                <b-td v-for="(question, index) in answerKey" :key="index">{{
                  question.myAnswer || "N/A"
                }}</b-td>
              </b-tr>
              <b-tr class="tsny_table-body">
                <b-td>
                  Correct answer:
                </b-td>
                <b-td v-for="(question, index) in answerKey" :key="index">{{
                  question.correctAnswer
                }}</b-td> </b-tr
              ><b-tr class="tsny_table-body">
                <b-td>
                  Topic:
                </b-td>
                <b-td v-for="(question, index) in answerKey" :key="index">{{
                  question.topic
                }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-collapse>
      </b-col>
    </b-row>
  </div></template
>

<script>
export default {
  name: "AnswerKey",
  props: {
    subsectionName: {
      type: String,
      default: null
    },
    answerKey: {
      type: Array,
      default: null
    }
  }
};
</script>

<style scoped></style>
